import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useMeteringRecord} from "../hooks/useMeteringRecord.ts";
import {MeteringRecord} from "../types.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {
        createRecord,
    } = useMeteringRecord();

    return (
        <FormDrawer
            record={{
                id: '',
                meterValue: 0,
                timestamp: '',
            } as MeteringRecord}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
